import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { selectCompanyId, selectCompanyTenantType, selectUserId } from './../redux/selectors/index';
import AnalyticsClient, { Traits } from './analyticsClient';

export default function useIdentify(additionalTraits?: Traits): void {
  const userId = useSelector(selectUserId);
  const companyId = useSelector(selectCompanyId);
  const tenantType = useSelector(selectCompanyTenantType);

  useEffect(() => {
    const traits = {
      company: companyId, // notice the "company". It should be passed like that
      tenantType,
      ...(additionalTraits || {}),
    };
    AnalyticsClient.identify(userId, traits);
  }, [userId, companyId, tenantType, additionalTraits]);
}
